import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { Box, Paper, Grid, Button, Chip } from "@mui/material";
import { useEffect, useState } from "react";
import { DurableFunctionStatusResponse, InviteGuestUserResponseDto, RefreshVendorsResponseDto } from "../helpers/InterfacesServer";
import { VerticalScrollableComponent } from "../layouts/VerticalScrollableComponent";
import { getlongRunningDurableFunctionStatus, longRunningOnboardPendingVendors } from "../api-services/VendorOnboardingApi";
import { useAppDispatch, useAppSelector } from '../store/store';
import { setVendors } from '../store/vendors';
import { setVendorUsers } from '../store/vendorUsers';
import { setVendorUsersDict } from '../store/vendorUsersDict';
import { showAlertInfo } from '../helpers/Utils';
import { useSearchParams } from 'react-router-dom';
import { setVendorInvitationsReportDict } from '../store/vendorInvitationsReportDict';


export function ViewOnboardPendingVendors() {
    const [searchParams,] = useSearchParams();
    const auth_code: string | null = searchParams.get("code")
    const initiateOnboardingOnLoadParams: string | null = searchParams.get("initiateOnboardingOnLoad")

    //state
    const dispatch = useAppDispatch()
    const invitationsReportDict = useAppSelector(state => state.vendorInvitationsReportDict.value);
    const [statusUrl, setStatusUrl] = useState<string | null>(null)
    const [status, setStatus] = useState<DurableFunctionStatusResponse<RefreshVendorsResponseDto> | null>(null)
    const [, setLoading] = useState(true);
    const [initiateOnboardingOnLoadCompleted, setInitiateOnboardingOnLoadCompleted] = useState(false);

    if (initiateOnboardingOnLoadParams === "1" && !initiateOnboardingOnLoadCompleted) {
        setInitiateOnboardingOnLoadCompleted(true);
        handleLongRunningOnboardPendingVendors();
    }

    function handleLongRunningOnboardPendingVendors() {
        longRunningOnboardPendingVendors(auth_code).then(result => {
            setStatusUrl(result.statusQueryGetUri)
        })
    }


    useEffect(() => {
        if (!statusUrl) return;
        const interval = setInterval(async () => {
            try {
                getlongRunningDurableFunctionStatus<RefreshVendorsResponseDto>(statusUrl).then(result => {
                    setStatus(result);
                    setLoading(false);
                    // Stop polling if completed or failed
                    if (result.runtimeStatus === 'Completed' && result.output) {
                        dispatch(setVendors(result.output.Vendors))
                        dispatch(setVendorUsers(result.output.VendorUsers));
                        dispatch(setVendorUsersDict(new Map(result.output.VendorUsers.map(vu => [vu.Email, vu]))));
                        // sort by Success status with true first
                        dispatch(setVendorInvitationsReportDict(new Map(result.output.InvitationsReport.sort((a, b) => (b.Success === a.Success) ? 0 : b.Success ? 1 : -1).map(vi => [vi.Email, vi]))));
                        if (result.output.ErrorMessages)
                            showAlertInfo(result.output.ErrorMessages, 'Pending Vendors Onboarding errors');
                    }
                    if (result.runtimeStatus === 'Completed' || result.runtimeStatus === 'Failed' || result.runtimeStatus === 'Terminated')
                        clearInterval(interval);
                })
            } catch (error) {
                console.error('Error fetching status:', error);
            }
        }, 10000); // Poll every 10 seconds
        return () => clearInterval(interval);
    }, [statusUrl, dispatch]);



    // Define columns
    const columns: MRT_ColumnDef<InviteGuestUserResponseDto>[] = [
        { accessorKey: 'Email', header: 'Email', size: 250, grow: 1 },
        {
            accessorKey: 'Success',
            header: 'Status',
            size: 150, sortDescFirst: true,
            Cell: ({ cell }) => (
                <Chip
                    label={cell.getValue<boolean>() ? 'Success' : 'Failed'}
                    color={cell.getValue<boolean>() ? 'success' : 'error'}
                    size="small"
                />
            ),
        },
        { accessorKey: 'StatusCode', header: 'Status Code' },
        { accessorKey: 'Description', header: 'Details', grow: 1 },
        {
            accessorKey: 'UserPrincipalName', header: 'UPN',
            muiTableBodyCellProps: {
                sx: {
                    whiteSpace: 'normal', // allows wrapping
                    wordBreak: 'break-word', // breaks long words
                    maxWidth: '200px', // optional: limit width for better wrapping
                },
            },
        },
        { accessorKey: 'UserId', header: 'ID' },
    ];



    return (
        <Box className='HorizontalOverFlowContainer'>
            <Paper className="Form">
                <br />
                <Box sx={{ width: '100%' }}>
                    <VerticalScrollableComponent viewPortHeightOffset={160}>
                        <Grid style={{ padding: 10 }} container justifyContent="right" size={{ xs: 12 }}>
                            {statusUrl &&
                                <Chip label={status?.runtimeStatus ?? "Loading Status..."} color={status?.runtimeStatus === "Completed" ? 'success' : (status?.runtimeStatus === "Running" ? 'warning' : 'error')} size="medium" />
                            } &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button disabled={statusUrl != null && status?.runtimeStatus !== 'Completed' && status?.runtimeStatus !== 'Failed' && status?.runtimeStatus !== 'Terminated'} variant="contained" color="secondary" onClick={() => { handleLongRunningOnboardPendingVendors() }}>Onboard All Pending Vendor Emails </Button>
                        </Grid>
                        <Grid style={{ padding: 10 }} >
                                <MaterialReactTable<InviteGuestUserResponseDto> columns={columns} data={statusUrl==null?[]:Array.from(invitationsReportDict.values())} enableColumnResizing enablePagination enableSorting enableColumnFilters
                                    mrtTheme={{ baseBackgroundColor: "#ffffff", }} muiTablePaperProps={{ elevation: 0, }}
                                />
                        </Grid>
                    </VerticalScrollableComponent>
                </Box>
                <br />
            </Paper>
        </Box>
    )
}
